import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { Mail, MessageSquare } from "lucide-react";

export default function MessageDialog({ channel, to, relatedType, relatedId, label }) {
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const Icon = channel === "email" ? Mail : MessageSquare;

  const send = async () => {
    if (!body.trim()) { toast.error("Write a message first"); return; }
    setBusy(true);
    try {
      await api.post("/admin/notifications/send", {
        channel, to, subject, body, related_type: relatedType, related_id: relatedId,
      });
      toast.success("Logged only — not emailed");
      setOpen(false); setBody(""); setSubject("");
    } catch {
      toast.error("Failed to log message");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" disabled={!to} data-testid={`msg-${channel}-btn`}>
          <Icon size={14} className="mr-1" /> {label}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>{channel === "email" ? "Email" : "Text"} {to}</DialogTitle></DialogHeader>
        <div className="bg-amber-50 border border-amber-200 text-amber-800 text-xs rounded p-2">
          Logged only — not emailed. Klaviyo / Twilio wiring is Phase 2 (placeholder).
        </div>
        {channel === "email" && (
          <div className="space-y-1.5">
            <Label className="text-xs">Subject</Label>
            <Input value={subject} onChange={(e) => setSubject(e.target.value)} />
          </div>
        )}
        <div className="space-y-1.5">
          <Label className="text-xs">Message</Label>
          <Textarea rows={5} value={body} onChange={(e) => setBody(e.target.value)} data-testid="msg-body" />
        </div>
        <DialogFooter>
          <Button onClick={send} disabled={busy} className="bg-[var(--panel-2)] text-[#c9a86a]">{busy ? "Sending…" : "Log Message"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
